import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateBlog from "../../components/Blog/UpdateBlog";

export const UpdateBlogPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateBlog />
        </div>
      </div>
    </div>
  );
};
